import { render, staticRenderFns } from "./drawerNew.vue?vue&type=template&id=2aed8f3a&scoped=true&"
import script from "./drawerNew.vue?vue&type=script&lang=js&"
export * from "./drawerNew.vue?vue&type=script&lang=js&"
import style0 from "./drawerNew.vue?vue&type=style&index=0&id=2aed8f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed8f3a",
  null
  
)

export default component.exports